var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", scrollable: "", width: "880", height: "620px" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "btn",
                      attrs: { text: "", disabled: !_vm.btnDisabledNewDelete },
                      on: {
                        click: function($event) {
                          return _vm.initData()
                        }
                      }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(_vm._s(_vm.$t("Add")))]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "popup add_store_popup" },
        [
          _c("v-card-title", [
            _c("h3", { staticClass: "page-title-bar" }, [
              _c("i", { staticClass: "ico ico-user" }),
              _vm._v(_vm._s(_vm.$t("New User")))
            ])
          ]),
          _c("v-card-text", [
            _c(
              "div",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            label: _vm.$t("User ID") + " *",
                            placeholder: _vm.$t("Input the ID"),
                            clearable: ""
                          },
                          on: {
                            keypress: _vm.handleKeyUp,
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                              _vm.clearTabindex
                            ]
                          },
                          model: {
                            value: _vm.account,
                            callback: function($$v) {
                              _vm.account = $$v
                            },
                            expression: "account"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            label: _vm.$t("Password") + " *",
                            placeholder: _vm.$t("Input the password"),
                            type: "password",
                            maxlength: _vm.max,
                            clearable: ""
                          },
                          on: {
                            input: _vm.passwordValidate,
                            keydown: _vm.clearTabindex
                          },
                          model: {
                            value: _vm.password,
                            callback: function($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.passwordPolicy
                  ? _c(
                      "div",
                      [
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#001e38",
                              "font-size": "14px"
                            }
                          },
                          [
                            _vm._v("Password Rules "),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*")
                            ])
                          ]
                        ),
                        _c(
                          "v-row",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c("v-col", { staticClass: "cols-6" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "popup-titbox mb-0",
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column"
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "frmValidation" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          class: {
                                            iconClassNot: !_vm.has_length,
                                            iconClass: _vm.has_length
                                          }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v("Contains 8 to 15 characters.")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "frmValidation mt-3" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          class: {
                                            iconClassNot: !_vm.has_uppercase,
                                            iconClass: _vm.has_uppercase
                                          }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v(
                                        "Include at least 1 uppercase letter."
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "frmValidation mt-3" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          class: {
                                            iconClassNot: !_vm.has_lowercase,
                                            iconClass: _vm.has_lowercase
                                          }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v(
                                        "Include at least 1 lower case letter."
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "frmValidation mt-3" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          class: {
                                            iconClassNot: !_vm.has_number,
                                            iconClass: _vm.has_number
                                          }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v("Include at least 1 number.")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "frmValidation mt-3" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          class: {
                                            iconClassNot: _vm.has_userid,
                                            iconClass: !_vm.has_userid
                                          }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v(
                                        "Password should not contains the user_id"
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _c("v-col", { attrs: { grow: "" } }, [
                              _c(
                                "p",
                                { staticClass: "frmValidation" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-4",
                                      class: {
                                        iconClassNot: !_vm.has_special,
                                        iconClass: _vm.has_special
                                      }
                                    },
                                    [_vm._v("mdi-checkbox-marked-circle")]
                                  ),
                                  _vm._v(
                                    "Include at least 1 special character."
                                  ),
                                  _c("br"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        "margin-left": "34px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "(*List all special characters and not just etc)"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "p",
                                { staticClass: "frmValidation mt-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-4",
                                      class: {
                                        iconClassNot: _vm.has_consicutive,
                                        iconClass: !_vm.has_consicutive
                                      }
                                    },
                                    [_vm._v("mdi-checkbox-marked-circle")]
                                  ),
                                  _vm._v(
                                    "Not use 3 consecutive characters. (abc, 123)"
                                  )
                                ],
                                1
                              ),
                              _c(
                                "p",
                                { staticClass: "frmValidation mt-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-4",
                                      class: {
                                        iconClassNot:
                                          _vm.has_consecutive_keyboard,
                                        iconClass: !_vm.has_consecutive_keyboard
                                      }
                                    },
                                    [_vm._v("mdi-checkbox-marked-circle")]
                                  ),
                                  _vm._v(
                                    "Not use 3 consecutive keyboard characters. (qwe, !23)"
                                  )
                                ],
                                1
                              ),
                              _c(
                                "p",
                                { staticClass: "frmValidation mt-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-4",
                                      class: {
                                        iconClassNot: _vm.has_repeat,
                                        iconClass: !_vm.has_repeat
                                      }
                                    },
                                    [_vm._v("mdi-checkbox-marked-circle")]
                                  ),
                                  _vm._v("Not repeat 3 characters. (aaa, 777)")
                                ],
                                1
                              ),
                              _c(
                                "p",
                                { staticClass: "frmValidation mt-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-4",
                                      class: {
                                        iconClassNot: !_vm.has_space,
                                        iconClass: _vm.has_space
                                      }
                                    },
                                    [_vm._v("mdi-checkbox-marked-circle")]
                                  ),
                                  _vm._v("Not use space.")
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("p", { staticClass: "label-txt" }, [
                          _vm._v(_vm._s(_vm.$t("User Level")) + " *")
                        ]),
                        _c(
                          "v-radio-group",
                          {
                            attrs: { dense: "", "hide-details": "", row: "" },
                            model: {
                              value: _vm.accessLevel,
                              callback: function($$v) {
                                _vm.accessLevel = $$v
                              },
                              expression: "accessLevel"
                            }
                          },
                          _vm._l(_vm.accessLevelItems, function(item) {
                            return _c(
                              "div",
                              { key: item.level },
                              [
                                item.level === "1"
                                  ? _c("v-radio", {
                                      key: item.level,
                                      staticClass: "form-radio flat",
                                      staticStyle: {
                                        "margin-right": "15px",
                                        padding: "8px"
                                      },
                                      attrs: {
                                        label: item.name,
                                        value: item.level,
                                        disabled: ""
                                      }
                                    })
                                  : _vm.userAccessLevel > item.level
                                  ? _c("v-radio", {
                                      key: item.level,
                                      staticClass: "form-radio flat",
                                      staticStyle: { padding: "8px" },
                                      attrs: {
                                        label: item.name,
                                        value: item.level,
                                        disabled: ""
                                      }
                                    })
                                  : _vm.userAccessLevel <= item.level
                                  ? _c("v-radio", {
                                      key: item.level,
                                      staticClass: "form-radio flat",
                                      staticStyle: { padding: "8px" },
                                      attrs: {
                                        label: item.name,
                                        value: item.level
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            label: _vm.$t("Name") + " *",
                            placeholder: "" + _vm.$t("Input the name"),
                            clearable: ""
                          },
                          on: { keydown: _vm.clearTabindex },
                          model: {
                            value: _vm.name,
                            callback: function($$v) {
                              _vm.name = $$v
                            },
                            expression: "name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            label: _vm.$t("Email Address") + " *",
                            placeholder: _vm.$t("Input the email address"),
                            clearable: "",
                            outlined: "",
                            dense: "",
                            "hide-details": ""
                          },
                          on: { keydown: _vm.clearTabindex },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            [
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _vm.passwordPolicy
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            text: "",
                            icon: "",
                            disabled: !_vm.savebutton
                          },
                          on: { click: _vm.clickSave }
                        },
                        [_vm._v(_vm._s(_vm.$t("Save")))]
                      )
                    : _vm._e(),
                  !_vm.passwordPolicy
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: { text: "", icon: "" },
                          on: { click: _vm.clickSave }
                        },
                        [_vm._v(_vm._s(_vm.$t("Save")))]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }